/**
 * Reduces a media source to origin + final path segment for error reporting.
 *
 * Cloudflare Stream signed URLs carry their JWT in a *path* segment rather than the query string,
 * so shipping the full URL to Sentry could put a credential in an error report. The origin is the
 * part with diagnostic value — it identifies which host failed.
 */
export function redactSrc(src: unknown): string | undefined {
  if (typeof src !== 'string') {
    return undefined
  }

  try {
    const { origin, pathname } = new URL(src, window.location.origin)
    const lastSegment = pathname.split('/').filter(Boolean).pop()

    return lastSegment ? `${origin}/…/${lastSegment}` : origin
  } catch {
    return undefined
  }
}
